<nz-input-number
  [name]="config.name"
  [nzPlaceHolder]="config.placeholder"
  [(ngModel)]="config.value"
  (ngModelChange)="onChange($event)"
  [nzMin]="config.min"
  [nzMax]="config.max"
  [nzStep]="config.step"
  [required]="config.required"
  style="width: 100%"
></nz-input-number>
